var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCloset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.045,
    height: 15.239,
    viewBox: "0 0 14.045 15.239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20368",
    "data-name": "Group 20368",
    transform: "translate(-6432.156 -4500)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7492",
    "data-name": "Path 7492",
    d: "M63.505,10H58.64v3.743h5.283V10.418A.419.419,0,0,0,63.505,10Z",
    transform: "translate(6382.276 4490)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7493",
    "data-name": "Path 7493",
    d: "M58.641,56.32h4.865a.419.419,0,0,0,.418-.418V48.91H58.641Zm1.923-5.936H62a.209.209,0,0,1,0,.419H60.564a.209.209,0,0,1,0-.419Z",
    transform: "translate(6382.276 4458.919)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7494",
    "data-name": "Path 7494",
    d: "M58.641,30.68h5.284v3.249H58.641Z",
    transform: "translate(6382.276 4473.481)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7495",
    "data-name": "Path 7495",
    d: "M38.281,25.239h3.677V10H38.281Zm2.706-8.293a.209.209,0,0,1,.418,0v1.439a.209.209,0,0,1-.418,0Z",
    transform: "translate(6398.54 4490)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7496",
    "data-name": "Path 7496",
    d: "M15.1,10.418v14.4a.419.419,0,0,0,.418.418h3.823V10H15.52a.418.418,0,0,0-.418.418Zm3.275,6.527a.208.208,0,0,1,.417,0v1.439a.208.208,0,0,1-.417,0Z",
    transform: "translate(6417.054 4490)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloset);
export default __webpack_public_path__ + "static/media/icon_closet.873ed259dd11f30a67d30b7760e487a4.svg";
export { ForwardRef as ReactComponent };